import api from './api';

const ENDPOINT = 'cities';

const NetworkService = {
  get: () => api.get(ENDPOINT),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  search: (term) => api.get(`${ENDPOINT}/search`, { params: { term } }),
};

export default NetworkService;
